import _defineProperty from "/workdir/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useContext } from 'react';
import { Box } from '@hub/box';
import { Tab } from '@hub/tabs';
import { LinkContext } from '../../../context';
import analyticsUtils from '../../../helpers/analytics-utils';
import trackEvent from '../../../helpers/analytics-utils/track-event';
import { jsx as _jsx } from "react/jsx-runtime";
export const TabItemList = ({
  tabName,
  selectedColour,
  url,
  sx = {}
}) => {
  const Link = useContext(LinkContext);
  const Component = url ? Box : Tab;

  const onClick = () => trackEvent(analyticsUtils.categories.UNIVERSAL_HEADER, analyticsUtils.actions.UNIVERSAL_HEADER_NAV_MENU_OPEN, tabName);

  return /*#__PURE__*/_jsx(Component, {
    as: url ? props => /*#__PURE__*/_jsx(Link, _objectSpread({
      to: url
    }, props)) : undefined,
    _selected: {
      bg: 'smoke',
      fontWeight: 'bold',
      borderTopColor: selectedColour,
      color: 'licorice'
    },
    sx: _objectSpread({
      flexGrow: 1,
      borderWidth: '2px',
      color: 'quartz',
      fontSize: 'font-tiny',
      fontWeight: 'bold',
      paddingX: 'spacing-md',
      paddingY: 'spacing-sm',
      borderRightRadius: '2px',
      borderLeftRadius: '2px',
      borderTopRightRadius: '2px',
      borderTopLeftRadius: '2px',
      borderTopStyle: 'solid',
      borderTopColor: 'transparent',
      lineHeight: 'base',
      whiteSpace: 'nowrap',
      textAlign: 'center'
    }, sx),
    onClick: onClick,
    children: tabName
  });
};